// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InviteKazooPlanner_container__GUzLJ {
  display: flex;
  gap: 60px;
  width: 100%;
  max-width: 800px;
}
@media (max-width: 768px) {
  .InviteKazooPlanner_container__GUzLJ {
    flex-direction: column;
    gap: 40px;
  }
}

.InviteKazooPlanner_partnerColumn__N-aCh {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.InviteKazooPlanner_partnerTitle__xV\\+uf {
  font-size: 24px;
  font-weight: 700;
  font-family: var(--font-bodoni);
  color: var(--primary-Text);
  margin: 0 0 12px 0;
}

.InviteKazooPlanner_subtitle__eo9Sj {
  font-size: 14px;
  color: #666;
  margin: 0 0 20px 0;
  line-height: 1.5;
}

.InviteKazooPlanner_partnerForm__P2bZj {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.InviteKazooPlanner_nameInputs__MDmfh {
  display: flex;
  gap: 10px;
}
.InviteKazooPlanner_nameInputs__MDmfh > div {
  flex: 1 1;
}
@media (max-width: 768px) {
  .InviteKazooPlanner_nameInputs__MDmfh {
    flex-direction: column;
    gap: 14px;
  }
}

.InviteKazooPlanner_inviteBtn__aVyq7 {
  width: fit-content;
  margin-top: 4px;
}

.InviteKazooPlanner_inviteStatus__QruvG {
  font-size: 13px;
  color: #666;
  margin: 0 0 12px 0;
  line-height: 1.4;
}
.InviteKazooPlanner_inviteStatus__QruvG strong {
  color: var(--primary-Text);
}

.InviteKazooPlanner_buttonGroup__HD8Ec {
  display: flex;
  gap: 12px;
}
@media (max-width: 768px) {
  .InviteKazooPlanner_buttonGroup__HD8Ec {
    flex-direction: column;
  }
}

.InviteKazooPlanner_resendBtn__CEr9Z {
  width: fit-content;
  background-color: #6c757d;
}
.InviteKazooPlanner_resendBtn__CEr9Z:hover {
  background-color: #5a6268;
}

.InviteKazooPlanner_removeBtn__obQZv {
  width: fit-content;
}`, "",{"version":3,"sources":["webpack://./src/components/invitePartner/InviteKazooPlanner.module.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;AACD;AACC;EAND;IAOE,sBAAA;IACA,SAAA;EAEA;AACF;;AACA;EACC,SAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAED;;AACA;EACC,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,0BAAA;EACA,kBAAA;AAED;;AACA;EACC,eAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AAED;;AACA;EACC,aAAA;EACA,sBAAA;EACA,SAAA;AAED;;AACA;EACC,aAAA;EACA,SAAA;AAED;AAAC;EACC,SAAA;AAEF;AACC;EARD;IASE,sBAAA;IACA,SAAA;EAEA;AACF;;AACA;EACC,kBAAA;EACA,eAAA;AAED;;AACA;EACC,eAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AAED;AAAC;EACC,0BAAA;AAEF;;AAEA;EACC,aAAA;EACA,SAAA;AACD;AACC;EAJD;IAKE,sBAAA;EAEA;AACF;;AACA;EACC,kBAAA;EACA,yBAAA;AAED;AAAC;EACC,yBAAA;AAEF;;AAEA;EACC,kBAAA;AACD","sourcesContent":[".container {\r\n\tdisplay: flex;\r\n\tgap: 60px;\r\n\twidth: 100%;\r\n\tmax-width: 800px;\r\n\r\n\t@media (max-width: 768px) {\r\n\t\tflex-direction: column;\r\n\t\tgap: 40px;\r\n\t}\r\n}\r\n\r\n.partnerColumn {\r\n\tflex: 1;\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tgap: 8px;\r\n}\r\n\r\n.partnerTitle {\r\n\tfont-size: 24px;\r\n\tfont-weight: 700;\r\n\tfont-family: var(--font-bodoni);\r\n\tcolor: var(--primary-Text);\r\n\tmargin: 0 0 12px 0;\r\n}\r\n\r\n.subtitle {\r\n\tfont-size: 14px;\r\n\tcolor: #666;\r\n\tmargin: 0 0 20px 0;\r\n\tline-height: 1.5;\r\n}\r\n\r\n.partnerForm {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tgap: 14px;\r\n}\r\n\r\n.nameInputs {\r\n\tdisplay: flex;\r\n\tgap: 10px;\r\n\r\n\t> div {\r\n\t\tflex: 1;\r\n\t}\r\n\r\n\t@media (max-width: 768px) {\r\n\t\tflex-direction: column;\r\n\t\tgap: 14px;\r\n\t}\r\n}\r\n\r\n.inviteBtn {\r\n\twidth: fit-content;\r\n\tmargin-top: 4px;\r\n}\r\n\r\n.inviteStatus {\r\n\tfont-size: 13px;\r\n\tcolor: #666;\r\n\tmargin: 0 0 12px 0;\r\n\tline-height: 1.4;\r\n\r\n\tstrong {\r\n\t\tcolor: var(--primary-Text);\r\n\t}\r\n}\r\n\r\n.buttonGroup {\r\n\tdisplay: flex;\r\n\tgap: 12px;\r\n\r\n\t@media (max-width: 768px) {\r\n\t\tflex-direction: column;\r\n\t}\r\n}\r\n\r\n.resendBtn {\r\n\twidth: fit-content;\r\n\tbackground-color: #6c757d;\r\n\t\r\n\t&:hover {\r\n\t\tbackground-color: #5a6268;\r\n\t}\r\n}\r\n\r\n.removeBtn {\r\n\twidth: fit-content;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `InviteKazooPlanner_container__GUzLJ`,
	"partnerColumn": `InviteKazooPlanner_partnerColumn__N-aCh`,
	"partnerTitle": `InviteKazooPlanner_partnerTitle__xV+uf`,
	"subtitle": `InviteKazooPlanner_subtitle__eo9Sj`,
	"partnerForm": `InviteKazooPlanner_partnerForm__P2bZj`,
	"nameInputs": `InviteKazooPlanner_nameInputs__MDmfh`,
	"inviteBtn": `InviteKazooPlanner_inviteBtn__aVyq7`,
	"inviteStatus": `InviteKazooPlanner_inviteStatus__QruvG`,
	"buttonGroup": `InviteKazooPlanner_buttonGroup__HD8Ec`,
	"resendBtn": `InviteKazooPlanner_resendBtn__CEr9Z`,
	"removeBtn": `InviteKazooPlanner_removeBtn__obQZv`
};
export default ___CSS_LOADER_EXPORT___;
